<template>
  <div id="app">
    <transition  name="fade" mode="out-in">
      <router-view :key="key"></router-view>
    </transition>
  </div>
</template>

<script>

import 'assets/less/index.less'
export default {
  name: 'index',
  computed: {
    key () {
      return this.$route.path.replace(/\//g, '-')
    }
  },
  mounted () {
  },
  methods: {
    goBack () {
      window.location.href = '../home.html'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/index.vue